import React from "react";
import trans from "../../utils";

export default function Image({ item, activeInput }) {
	return (
		<>
			{item?.imgPath ? (
				<>
					<div style={item?.css}>
						<img
							src={item?.imgPath}
							alt="Form Input"
							key={activeInput}
							style={{
								width: "100%",
								height: "auto",
								borderRadius: "8px",
							}}
						/>
					</div>
				</>
			) : (
				<div>{trans("No Image Uploaded")}</div>
			)}
		</>
	);
}
